export default "__VITE_ASSET__b64bf5af__"